import { render } from "./Theme&Color.md?vue&type=template&id=6ddb6b48"
const script = {}
script.render = render

export default script